import { GlButton } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
/**
 * Port of detail_behavior expand button.
 *
 * @example
 * <expand-button expand-label="Expand details" collapse-label="Collapse details">
 *   <template #expanded>
 *      Text goes here.
 *    </template>
 * </expand-button>
 */ export default {
    name: 'ExpandButton',
    components: {
        GlButton
    },
    props: {
        expandLabel: {
            type: String,
            required: true
        },
        collapseLabel: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            isCollapsed: true
        };
    },
    destroyed () {
        this.isCollapsed = true;
    },
    methods: {
        onClick () {
            this.isCollapsed = !this.isCollapsed;
        }
    }
};
